import { Component, Input } from '@angular/core';
import { MessageService } from 'primeng/api';
import { AppComponent } from 'app/app.component';

@Component({
    selector: 'partner-settings-business-info',
    templateUrl: './partner-settings-business-info.component.html',
    styleUrls: ['./partner-settings-business-info.component.scss',
        '../../../../../styles/style-layout.scss']
})

export class PartnerSettingsBusinessInfoComponent {
    @Input()
    public menuPermissionActive!: string;

    constructor(private messageService: MessageService, public app: AppComponent) {
        this.handleBusinessInfoUpdateHide = this.handleBusinessInfoUpdateHide.bind(this);
    }
    @Input()
    public businessInfo: any;

    public showBusinessInfoUpdateSidebar: boolean = false;

    public handleBusinessInfoUpdateHide() {
        this.showBusinessInfoUpdateSidebar = false;
    }
    public handleShowBusinessInfoUpdate() {
        this.showBusinessInfoUpdateSidebar = true;
    }
}
